export enum XpoLtlShipmentDetailsTabs {
  Details = 'Details',
  History = 'History',
  Charges = 'Charges',
}
